module.exports = __webpack_public_path__ + "img/wallet-consumption-icon.342830a1.svg";